<template>
  <LinkCard
    :icon="iconComp"
    :image="thumbnail"
    :title="$path('title', value)"
    :badges="badges"
    :is-list="isList"
    :to="$attrs.to || { name: 'post-edit', params: { id: value.id } }"
  >
    <template #subtitle>
      <StatusIndicator v-bind="status" />
    </template>
  </LinkCard>
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    value: Object,
    icon: {
      type: Array,
      default: () => ['fal', 'newspaper'],
    },
    tags: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    iconComp() {
      return this.icon[0] instanceof Array ? this.icon[0] : this.icon
    },
    isList() {
      return this.theme === 'list'
    },

    thumbnail() {
      return getCoverThumbnail(this.$path('value.media.cover') || [])
    },

    status() {
      if (this.value.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
    badges() {
      return [
        this.value.demo ? { theme: 'warning', value: this.$t('demo') } : null,
        ...this.tags.map(tag => ({ theme: 'primary', value: tag })),
      ].filter(Boolean)
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
